import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import axios from 'axios';
import { useUser } from './UserContext';
import { Club } from '../types/ClubTypes';
interface ClubContextType {
  club: Club;
  isLoading: boolean;
  error: string | null;
}

const ClubContext = createContext<ClubContextType | undefined>(undefined);

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/api";

export const ClubProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { isAuthenticated } = useAuth();
  const { user } = useUser();
  const [club, setClub] = useState<Club>(user?.club as Club);

  const fetchClubData = async () => {
    setIsLoading(true);
    await axios
    .get(`${API_BASE_URL}/clubs/user_club/`)
    .then((response) => {
      setClub(response.data);
    })
    .catch((error) => {
      console.error('Error fetching club data:', error);
      setError('Failed to load club data');
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchClubData();
    }
  }, [isAuthenticated]);

  return (
    <ClubContext.Provider value={{ club, isLoading, error }}>
      {children}
    </ClubContext.Provider>
  );
};

export const useClub = () => {
  const context = useContext(ClubContext);
  if (context === undefined) {
    throw new Error('useClub must be used within a ClubProvider');
  }
  return context;
}; 